var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('CardsListTag',{attrs:{"tagId":_vm.id,"title":_vm.tag().name}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }